<div class="popup-container" >
    <div class="popup-model">
        <div class="popup-header">
            <div class="popup-header-Icon"></div>
            <div class="popup-header-text">{{headerTitle}}</div>
            <div class="popup-header-Icon2"></div>
            <div class="popup-close" (click)="close()" title="Close"></div>
        </div>
        <div class="popup-body">
          <div class="loader-container" *ngIf="!showLoader">
            <div class="loader"></div>
          </div>
          <div class="message-block" *ngIf="showLoader && showError">
            <markdown [data]="messageText"></markdown>
          </div>
          <div class="bulb-Icon-Container">
            <div class="bulb-Icon"></div>
          </div>
        </div>

    </div>
</div>

